import { render, staticRenderFns } from "./TripLegSelector.vue?vue&type=template&id=5b5c9813&"
import script from "./TripLegSelector.vue?vue&type=script&lang=js&"
export * from "./TripLegSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports